@if (!row()) {
    <app-icon
        name="tabler:pinned-filled"
        [ngClass]="isPinned() ? 'text-primary' : 'text-gray-200'"
    />
} @else {
    <app-icon
        name="tabler:pinned-filled"
        [ngClass]="row()?.isPinned ? 'text-primary' : 'text-gray-200'"
    />
}
